import React from 'react';
import {List, List2} from '../../../components';
import './ValueCard1.less';

function Table({cols, items}) {
  const renderItem = (item, index) => {
    return (
      <tr key={index}>
        {item.map((col, index) => <td key={index}>{col}</td>)}
      </tr>
    );
  };
  return (
    <div className='Table'>
      <table>
        <thead>
        <tr>{cols.map((col, index) => <th key={index}>{col}</th>)}</tr>
        </thead>
        <tbody>
        {items.map(renderItem)}
        </tbody>
      </table>
    </div>
  );
}

function ValueCard1({data, type}) {
  if (!data.cols) {
    if (type === 2) {
      return (
        <div className='ValueCard1'>
          <h2>{data.title}</h2>
          <List2 items={data.items}/>
        </div>
      );
    } else {
      return (
        <div className='ValueCard1'>
          <h2>{data.title}</h2>
          <List items={data.items}/>
        </div>
      );
    }
  } else {
    return (
      <div className='ValueCard1'>
        <h2>{data.title}</h2>
        <Table cols={data.cols} items={data.items} />
      </div>
    );
  }
}

export default ValueCard1;


// WEBPACK FOOTER //
// ./src/routes/Case/ValueCard/ValueCard1.js